import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useState } from "react";
import { getI18n, useTranslation } from "react-i18next";

const countryFlags = ["fr", "de", "it"];

export function getLanguageCode():string {
    let lang = getI18n().languages[0];
    if (!lang) {
        lang = window.navigator.language && window.navigator.language.includes('-') ? window.navigator.language.split('-')[0] : window.navigator.language;
    }
    return lang;
}

const LanguageSelector = () => {
    const { t } = useTranslation();
    const [lang, setLang] = useState(getLanguageCode());

    const handleChange = (event: SelectChangeEvent) => {
        setLang(event.target.value as string);
        getI18n().changeLanguage(event.target.value);
    };

    const getCountrySvg = (code: string) => {
        return <img src={process.env.PUBLIC_URL + "/svgFiles/" + code + '.svg'} alt="" aria-hidden="true" />
    }

    return (
        <FormControl sx={{ m: 1, minWidth: 40 }} size="small">
            <Select
                value={lang}
                onChange={handleChange}
                inputProps={{ "aria-label": t("a11y.chooseLanguage") }}
                sx={{ boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
            >
                {countryFlags.map((code) => (
                    <MenuItem value={code} key={code} aria-label={t(`language.${code}`)}>
                        {getCountrySvg(code)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default LanguageSelector;
